// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"66":"d9a4ced2","338":"a717b7f4"}[chunkId] + ".css";
};